import { computed } from "vue";

import { config } from "@/config";

function appStoreUrl(url: string) {
  const languageCountryMap = {
    da: "dk",
    de: "de",
    en: "us"
  };

  const language = config.app.language as keyof typeof languageCountryMap;

  return url.replace(/{country}/g, languageCountryMap[language]).replace(/{language}/g, language);
}

export function useAppLink() {
  const { externalLinks } = config;

  const chromeExtensionLink = externalLinks.browserExtension.chrome;
  const edgeExtensionLink = externalLinks.browserExtension.edge;
  const fireFoxExtensionLink = externalLinks.browserExtension.fireFox;

  const androidAppLink = externalLinks.mobileApp.android;
  const iosAppLink = computed<string>(() => appStoreUrl(externalLinks.mobileApp.ios));

  const op5MacLink = computed<string>(() => appStoreUrl(externalLinks.op5.mac));
  const op5WindowsLink = externalLinks.op5.windows;
  const op5MsiLink = externalLinks.op5.msi;

  return {
    chromeExtensionLink,
    edgeExtensionLink,
    fireFoxExtensionLink,

    androidAppLink,
    iosAppLink,

    op5MacLink,
    op5WindowsLink,
    op5MsiLink
  };
}
